module.exports = __webpack_public_path__ + "img/avatar-2.9ce030c2.jpg";